import React, { useState } from 'react';
import classnames from 'classnames';
import { includes, map } from 'lodash/fp';
import IconCaret from '../../files/caret.svg';

const NAV_KEYS = [
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'PageUp',
  'PageDown',
  'Home',
  'End',
];

const SelectOption = ({ label, value }) => (
  <option key={label} value={value}>
    {label}
  </option>
);

const SelectBox = ({
  id,
  responsive = false,
  imageUrl,
  title,
  description,
  placeholder = 'Select an option',
  options = [],
}) => {
  const isBrowser = typeof window !== 'undefined';

  const [arrowKeyPressed, setArrowKeyPressed] = useState(false);

  const handleKeyDown = (evt) => {
    const { key } = evt;
    if (includes(key, NAV_KEYS)) {
      setArrowKeyPressed(true);
    }
    if (key === 'Escape') {
      evt.target.value = '';
      setArrowKeyPressed(false);
    }
  };

  const handleChange = (evt) => {
    const {
      target: { value },
    } = evt;
    if (isBrowser && value && !arrowKeyPressed) {
      window.location.href = value;
    }
    if (arrowKeyPressed) {
      setArrowKeyPressed(false);
    }
  };

  const cardClasses = classnames('select-box card card--blue-pale', {
    'card--responsive': responsive,
  });

  const titleId = `${id}-title`;

  return (
    <div className={cardClasses}>
      <div className="card__wrapper">
        {imageUrl && (
          <div
            className="card__image select-box__image"
            style={{ backgroundImage: `url(${imageUrl})` }}
          ></div>
        )}
        <div className="card__content">
          <div
            id={titleId}
            className="card__title card__title--uppercase select-box__title"
          >
            {title}
          </div>
          {description && (
            <div className="card__description">{description}</div>
          )}
          <div className="select-box__control">
            <select
              id={id}
              className="select-box__select"
              aria-labelledby={titleId}
              onChange={handleChange}
              onBlur={handleChange}
              onKeyDown={handleKeyDown}
            >
              <option value="">{placeholder}</option>
              {map(SelectOption, options)}
            </select>
            <span className="select-box__toggle">
              <IconCaret focusable={false} className="select-box__icon" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectBox;
